import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-anzeigen-kondolenz-create',
  templateUrl: './anzeigen-kondolenz-create.component.html',
  styleUrls: ['./anzeigen-kondolenz-create.component.scss']
})
export class AnzeigenKondolenzCreateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
